import React, { lazy } from 'react';
import { Navigate } from 'react-router-dom';

import { RouteErrorBoundary } from '$components/uhoh/fatal-error';

const Home = lazy(() => import('./components/home'));
const AboutUs = lazy(() => import('./components/aboutus'));
const DemoVideos = lazy(() => import('./components/demo-videos'));
const Models = lazy(() => import('./components/models'));
const TermsOfUse = lazy(() => import('./components/terms-use'));
const Methodology = lazy(() => import('./components/methodology'));
const SupplyChain = lazy(() => import('./components/supply-chain/index'));
const EnvironmentalJustice = lazy(
  () => import('./components/risk-map/flaring-risk/index')
);
const HydrogenSulfide = lazy(
  () => import('./components/risk-map/hydrogen-sulfide/index')
);
const Analysis = lazy(() => import('./components/analysis/index'));
const CountryPage = lazy(() => import('./components/country/index'));
const OilDetail = lazy(() => import('./components/oil/index'));
const CompareOil = lazy(() => import('./components/compare-oil/index'));
const Glossary = lazy(() => import('./components/glossary'));
const EconomicCrudeGrade = lazy(
  () => import('./components/economic/crude-grade')
);
const EconomicBreakevenPrice = lazy(
  () => import('./components/economic/breakeven-price')
);
const TotalEmissions = lazy(() => import('./components/total-emissions'));
const Scenarios = lazy(() => import('./components/scenarios/hub'));
const EachScenario = lazy(() => import('./components/scenarios/single'));
const Studies = lazy(() => import('./components/studies'));
const UhOh = lazy(() => import('./components/uhoh'));

const withRouteErrorBoundary = (route) => ({
  ErrorBoundary: RouteErrorBoundary,
  ...route
});

export const routes = [
  withRouteErrorBoundary({
    index: true,
    element: <Home />
  }),
  withRouteErrorBoundary({
    path: 'about/demovideos',
    element: <DemoVideos />
  }),
  withRouteErrorBoundary({
    path: 'about/models',
    element: <Models />
  }),
  withRouteErrorBoundary({
    path: 'about/termsofuse',
    element: <TermsOfUse />
  }),
  withRouteErrorBoundary({
    path: 'about/us',
    element: <AboutUs />
  }),
  withRouteErrorBoundary({
    path: 'about/studies',
    element: <Studies />
  }),
  withRouteErrorBoundary({
    path: 'methodology',
    element: <Methodology />
  }),
  withRouteErrorBoundary({
    path: 'supply-chain',
    element: <SupplyChain />
  }),
  withRouteErrorBoundary({
    path: 'supply-chain/country/:iso3',
    element: <CountryPage />
  }),
  withRouteErrorBoundary({
    path: 'analysis',
    element: <Analysis />
  }),
  withRouteErrorBoundary({
    path: 'total-emissions',
    element: <TotalEmissions />
  }),
  withRouteErrorBoundary({
    path: 'flaring-risk-map',
    element: <EnvironmentalJustice />
  }),
  withRouteErrorBoundary({
    path: 'hydrogen-sulfide-risk',
    element: <HydrogenSulfide />
  }),
  withRouteErrorBoundary({
    path: 'economics/benchmark-crude',
    element: <EconomicCrudeGrade />
  }),
  withRouteErrorBoundary({
    path: 'economics/breakeven-price-of-production',
    element: <EconomicBreakevenPrice />
  }),
  withRouteErrorBoundary({
    path: 'map',
    element: <Navigate to='/' replace />
  }),
  withRouteErrorBoundary({
    path: 'oil/:oilId',
    element: <OilDetail />
  }),
  withRouteErrorBoundary({
    path: 'compare/:oilId/:oilToCompareId',
    element: <CompareOil />
  }),
  withRouteErrorBoundary({
    path: 'scenarios',
    element: <Scenarios />
  }),
  withRouteErrorBoundary({
    path: 'scenarios/:caseId',
    element: <EachScenario />
  }),
  withRouteErrorBoundary({
    path: 'glossary',
    element: <Glossary />
  }),
  withRouteErrorBoundary({
    path: '*',
    element: <UhOh />
  })
];
